'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Loads a custom page's bundle and hydrates #dineator-root. Runs as an effect so it works however the page was reached:
 * a hard load and a soft (Next <Link>) navigation alike, since React never executes <script> tags it renders on the client.
 * The bundle (compile.ts CLIENT_ENTRY) only defines `__page.mount(root, props)`; the returned function unmounts it.
 */
export default function CustomPageMount({ src, config }: { src: string; config: { slug: string; apiUrl: string } }) {
  const router = useRouter();
  useEffect(() => {
    const g = globalThis as typeof globalThis & {
      __DINEATOR__?: unknown;
      __page?: { mount?: (root: Element, props: unknown) => () => void };
    };
    g.__DINEATOR__ = { ...config, navigate: (href: string) => router.push(href) }; // page-kit <Link>
    let unmount: (() => void) | undefined;
    let cancelled = false;
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = () => {
      const root = document.getElementById('dineator-root');
      const raw = document.getElementById('dineator-props')?.textContent;
      const mount = g.__page?.mount;
      if (cancelled || !root || !raw || typeof mount !== 'function') return;
      unmount = mount(root, JSON.parse(raw));
    };
    document.body.appendChild(s);
    return () => {
      cancelled = true;
      s.remove();
      unmount?.();
    };
  }, [src, config.slug, config.apiUrl, router]); // eslint-disable-line react-hooks/exhaustive-deps -- config is a fresh object each render
  return null;
}
